<div class="current-time-linear" [hidden]="!isExistChildBlock" title="{{ hoursDate + ':' + minutesDate }}"></div>
